var map = {
	"./arrow-down.svg": 4746,
	"./btn.svg": 6011,
	"./chat.svg": 5166,
	"./check.svg": 706,
	"./heart.svg": 3972,
	"./icon-1.svg": 2872,
	"./icon-1_act.svg": 6218,
	"./icon-2.svg": 2559,
	"./icon-2_act.svg": 8812,
	"./logo.svg": 3190,
	"./modal-logo.svg": 7090,
	"./service-1.svg": 2853,
	"./service-1_act.svg": 1726,
	"./service-2.svg": 7871,
	"./service-2_act.svg": 9664,
	"./service-3.svg": 6088,
	"./service-3_act.svg": 9875,
	"./service-4.svg": 2478,
	"./service-4_act.svg": 4212,
	"./service-5.svg": 9262,
	"./service-5_act.svg": 6995,
	"./service-6.svg": 1708,
	"./service-6_act.svg": 4792,
	"./star.svg": 3740,
	"./vtr-1.svg": 7929,
	"./vtr-2.svg": 9923,
	"./vtr-3.svg": 6425,
	"./vtr-4.svg": 4769,
	"./vtr-5.svg": 188
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8091;